import { GET_CHANGE_HISTORY, GET_CHANGE_HISTORY_EXPORT } from "./actionTypes"
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"
import { getChangeHistoryError, getChangeHistoryExportError, getChangeHistoryExportSuccess, getChangeHistorySuccess } from "./actions"
import { genericGetRequest_2 } from "../../helpers/sf_backend_helper";

import { AppConfiguration } from "config";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import { buildChangeHistoryCacheKey } from "helpers/change_history_pagination_helper";
import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper";
import { showExportEnqueuedToast } from "helpers/export_toast_helper";

const inFlightChangeHistoryRequests = new Set()

function* onGetChangeHistory(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const queryParams = action.payload?.queryParams || {}
    const useCache = Boolean(action.payload?.useCache)
    const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
    const cacheKey = useCache ? buildChangeHistoryCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.ChangeHistory.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightChangeHistoryRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightChangeHistoryRequests.add(requestKey)
    }

    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/history_versions`,
      queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getChangeHistorySuccess(response, {
      queryParams,
      appendResults: Boolean(action.payload?.appendResults),
      useCache,
    }))
  } catch (error) {
    yield put(getChangeHistoryError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action.payload?.queryParams || {}
      const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
      const cacheKey = buildChangeHistoryCacheKey(queryParams)
      inFlightChangeHistoryRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}

function* onGetChangeHistoryExport(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/history_versions_export`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getChangeHistoryExportSuccess())
    showExportEnqueuedToast({ reportExportsAvailable: bsh_isAdminUserDetailsPresent() });
  } catch (error) {
    yield put(getChangeHistoryExportError())
    ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Export failed due to some unexpected error' });
  }
}

function* changeHistorySaga() {
  yield takeLatest(GET_CHANGE_HISTORY, onGetChangeHistory);
  yield takeEvery(GET_CHANGE_HISTORY_EXPORT, onGetChangeHistoryExport);
}

export default changeHistorySaga;
